// TODO: This was migrated from portico UI and will need tests eventually. It's slightly different than the portico UI version used elsewhere

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import React, { useState } from 'react';
import { FieldError } from 'react-hook-form/dist/types';
import Spacing from '../../components/portico/spacing';
import ErrorMessage from '../../components/portico/error-message';
import { withFormError, withFormRef } from '../../components/portico/form-integration';
import useRadioGroupStyles from './radiogroup.styles';

interface RadioGroupItem {
    label: string,
    value: string
}

interface RadioGroupProps {
    uiRenderOptions?: any;
    label: string;
    name: string;
    items: RadioGroupItem[];
    value: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
    hasError?: boolean;
    errorMessage?: string;
    error?: FieldError;
    inputRef?: React.Ref<HTMLElement>;
    ref?: React.Ref<HTMLElement>;
    unregister?: Function;
}

const Radiogroup: React.FC<RadioGroupProps> = ({
    uiRenderOptions,
    label,
    name,
    items,
    value,
    onChange,
    hasError,
    errorMessage,
    inputRef,
    ...props
}) => {
    const classes = useRadioGroupStyles();
    const [innerValue, setInnerValue] = useState<string>(value || '');
    //const row = "row";
    const handleChange = (_event: React.ChangeEvent<HTMLInputElement>, _value: string) => {
        setInnerValue(_value);
        if (onChange) {
            onChange(_event, _value);
        }
    };

    const getRowStyle = () => {
        if (uiRenderOptions == undefined || uiRenderOptions == null) {
            return true;
        }
        return uiRenderOptions.row;
    }

    return (
        <FormControl fullWidth>
            <RadioGroup
                id='radio-group'
                name={name}
                value={innerValue}
                onChange={handleChange}
                className={getRowStyle() ? classes.radioGroupRow : classes.radioGroupColumn}
                {...props}
            >
                {Array.isArray(items)
                    && items.map((item, index) => (<React.Fragment key={index}>
                        {index !== 0 && <Spacing variable="spacing-base-x1" />}
                        <FormControlLabel value={item.value} label={item.label} control={<Radio color="primary" inputRef={inputRef} />} />
                    </React.Fragment>
                    ))}
            </RadioGroup>
            {hasError && <ErrorMessage message={errorMessage || ''} />}
        </FormControl>
    );
};

export default withFormRef(withFormError(Radiogroup)) as React.FC<RadioGroupProps>;